import React from "react";
import { render } from "react-snapshot";
import App from "./routes/App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
